import type { ComponentPropsWithRef, JSX } from "react";
import { cx } from "../cx";

export type ButtonVariant = "primary" | "volt" | "secondary" | "ghost";
export type ButtonSize = "sm" | "md" | "lg";

export interface ButtonProps extends ComponentPropsWithRef<"button"> {
  /**
   * Visual style. `primary` is blue-800; `volt` is the rationed accent (max
   * one per view); `secondary` is a hairline outline; `ghost` is quiet.
   */
  variant?: ButtonVariant | undefined;
  /** Control height: 30 / 38 / 48px. */
  size?: ButtonSize | undefined;
}

/**
 * Tarski button. 2px radius; hover darkens one step, press darkens again,
 * never scales. Ported from design/tarski-kit/components/actions/Button.jsx.
 */
export function Button({
  variant = "primary",
  size = "md",
  type = "button",
  className,
  children,
  ...rest
}: ButtonProps): JSX.Element {
  return (
    <button
      type={type}
      className={cx("tk-button", `tk-button--${variant}`, `tk-button--${size}`, className)}
      {...rest}
    >
      {children}
    </button>
  );
}
